/* TLB-20261029-review-block: connects the review summary (sections/tlb-reviews.liquid) to the Judge.me widget below it. */
(function () {
  'use strict';

  var WIDGET = '.jdgm-widget.jdgm-review-widget';
  var PETS = ['cat', 'fox', 'owl', 'bear', 'bunny', 'chick', 'mouse', 'puppy'];

  function widgetIn(root) {
    return root.querySelector(WIDGET) || document.querySelector(WIDGET);
  }

  // Reviewers without a photo get an animal from snippets/tlb-review-sprite.liquid,
  // picked from the review id so the same review always shows the same animal.
  // Judge.me empties the icon once while it sets up, so this re-adds any that went missing.
  function addPets(root) {
    root.querySelectorAll('.jdgm-rev__icon').forEach(function (icon) {
      if (icon.querySelector('svg, img')) return;
      var rev = icon.closest('.jdgm-rev');
      var id = (rev && rev.getAttribute('data-review-id')) || '';
      var n = 0;
      for (var i = 0; i < id.length; i++) n = (n * 31 + id.charCodeAt(i)) % 9973;
      icon.classList.add('tlb-rv__pet');
      icon.innerHTML = '<svg aria-hidden="true" focusable="false"><use href="#tlb-av-' + PETS[n % PETS.length] + '"/></svg>';
    });
  }

  // Long reviews start cut to a few lines (tlb-reviews-judgeme.css) with a link to open them.
  // All reads happen before all writes, so a page of reviews costs two layouts, not two per review.
  function clampLong(root) {
    // Skip bodies Judge.me still keeps hidden; they cannot be measured yet.
    // Bodies holding a searched word stay open, so the word is in sight. Judge.me marks only whole
    // words, so a part match ("grand" in "grandson") is found by its text.
    var field = root.querySelector('.jdgm-review-search');
    var term = field && field.value ? field.value.toLowerCase() : '';
    var bodies = [].filter.call(root.querySelectorAll('.jdgm-rev__body:not([data-tlb-clamp])'), function (body) {
      if (body.offsetHeight <= 0 || body.querySelector('mark')) return false;
      return !(term && body.textContent.toLowerCase().indexOf(term) > -1);
    });
    bodies.forEach(function (body) {
      body.dataset.tlbClamp = '1';
      body.classList.add('tlb-rv__clamp');
    });
    // Only cut when it hides at least two lines; opening a single hidden line is not worth a tap.
    var long = bodies.map(function (body) {
      return body.scrollHeight > body.clientHeight * 1.4;
    });
    bodies.forEach(function (body, i) {
      if (!long[i]) {
        body.classList.remove('tlb-rv__clamp');
        return;
      }
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'tlb-rv__more-btn';
      more.textContent = 'Read more';
      more.addEventListener('click', function () {
        more.textContent = body.classList.toggle('tlb-rv__clamp') ? 'Read more' : 'Show less';
      });
      body.after(more);
    });
  }

  // "Parents mention" tags list the reviews that mention them through Judge.me's own review search: the widget
  // sends the value of a .jdgm-review-search field with every page, sort and star request, and marks the word
  // in each review. The search bar is switched off in Judge.me, so a hidden field stands in for it.
  function searchField(widget) {
    return widget && widget.querySelector('.jdgm-review-search');
  }

  function runSearch(widget, term) {
    var field = searchField(widget);
    if (!field) {
      if (!term) return;
      field = document.createElement('input');
      field.type = 'hidden';
      field.className = 'jdgm-review-search';
      widget.prepend(field);
    }
    if (field.value === term) return;
    field.value = term;
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Judge.me can list only reviews with pictures, but the option sits inside its sort menu.
  // Two chips beside the menu reach it in one tap. Its menu is drawn after load, so this runs from the
  // observer until the menu exists; without a pictures option nothing is added. Judge.me may redraw the
  // menu later, so the menu is looked up again on every tap and every redraw, never kept.
  // Judge.me's review form has a select with the same class; the sort menu is the one offering pictures.
  function sortMenu(app) {
    var opt = app.querySelector('.jdgm-sort-dropdown option[value="with-pictures"]');
    return opt && opt.closest('select');
  }

  function addPhotoChips(app) {
    var sel = sortMenu(app);
    if (!sel) return;
    var row = app.querySelector('.tlb-rv__chips');
    if (!row) {
      row = document.createElement('div');
      row.className = 'tlb-rv__chips';
      row.setAttribute('role', 'group');
      row.setAttribute('aria-label', 'Show reviews');
      row.innerHTML =
        '<button type="button" class="tlb-rv__chip" data-tlb-sort="">All</button>' +
        '<button type="button" class="tlb-rv__chip" data-tlb-sort="with-pictures">With photos</button>';
      row.addEventListener('click', function (event) {
        var chip = event.target.closest('.tlb-rv__chip');
        var menu = sortMenu(app);
        if (!chip || !menu) return;
        var v = chip.dataset.tlbSort || app.dataset.tlbBase || 'most-recent';
        if (menu.value === v) return;
        menu.value = v;
        menu.dispatchEvent(new Event('change', { bubbles: true }));
      });
      app.addEventListener('change', function (event) {
        if (event.target.matches('.jdgm-sort-dropdown')) addPhotoChips(app);
      });
      app.prepend(row);
    }
    if (sel.value !== 'with-pictures') app.dataset.tlbBase = sel.value;
    row.querySelectorAll('.tlb-rv__chip').forEach(function (chip) {
      chip.setAttribute('aria-pressed', String((chip.dataset.tlbSort || app.dataset.tlbBase) === sel.value));
    });
  }

  // Once the page scrolls past it, the theme header stays pinned to the top of the screen and covers what
  // is scrolled right to the top, so scrolls to the review list stop just below it.
  function headerCover() {
    var header = document.querySelector('.shopify-section-header-sticky');
    var box = header && header.getBoundingClientRect();
    return box && box.top <= 1 && box.bottom > 0 ? box.bottom : 0;
  }

  function scrollBelowHeader(el) {
    var top = window.scrollY + el.getBoundingClientRect().top - headerCover() - 12;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  // Judge.me asks jdgmSettings.scrollTo before each of its own scrolls (after a search, a star filter or a
  // page change) and skips the scroll when it returns false. Scrolls to the list in this block go below
  // the header instead; any other keeps Judge.me's own behaviour.
  function takeOverJudgeMeScroll() {
    var settings = window.jdgmSettings;
    if (!settings || settings.tlbScroll) return;
    var own = settings.scrollTo;
    settings.tlbScroll = true;
    settings.scrollTo = function (target) {
      var el = target && target[0];
      if (el && el.closest && el.closest('[data-tlb-reviews]')) {
        scrollBelowHeader(el);
        return false;
      }
      return typeof own === 'function' ? own.apply(this, arguments) : undefined;
    };
  }

  // Judge.me scrolls its own list into view after a star filter or a search. Scroll only if it did not.
  function scrollToList(widget) {
    var target = widget.querySelector('.jdgm-rev-widg__body') || widget;
    setTimeout(function () {
      var top = target.getBoundingClientRect().top;
      if (top < headerCover() || top > window.innerHeight / 2) scrollBelowHeader(target);
    }, 700);
  }

  // Judge.me filters by star when its own histogram row is clicked; ours triggers that row.
  function pressJudgeMe(widget, rating) {
    var el = rating
      ? widget.querySelector('.jdgm-histogram__row[data-rating="' + rating + '"] .jdgm-histogram__star') ||
        widget.querySelector('.jdgm-histogram__row[data-rating="' + rating + '"]')
      : widget.querySelector('.jdgm-histogram__clear-filter');
    if (!el) return false;
    el.click();
    return true;
  }

  function init(root) {
    if (!root || root.dataset.tlbReady) return;
    root.dataset.tlbReady = '1';
    takeOverJudgeMeScroll();

    // Judge.me draws its list after load and again on every page or filter change.
    // The observer hands over each burst of changes in one call, before the page paints.
    var app = root.querySelector('.tlb-rv__app') || root;
    var tags = root.querySelectorAll('[data-tlb-search]');
    var found = root.querySelector('[data-tlb-found]');

    // Tags and the line above the list follow the search field, which Judge.me may also clear.
    // The line moves to the top of Judge.me's list, where Judge.me scrolls after a search.
    function syncSearch() {
      var field = searchField(widgetIn(root));
      var term = (field && field.value) || '';
      var label = term;
      tags.forEach(function (tag) {
        var on = term !== '' && tag.dataset.tlbSearch === term;
        tag.setAttribute('aria-pressed', String(on));
        if (on) label = tag.textContent;
      });
      if (!found) return;
      var list = app.querySelector('.jdgm-rev-widg__body');
      if (list && found.parentNode !== list) list.prepend(found);
      found.hidden = !term;
      var name = found.querySelector('[data-tlb-found-tag]');
      if (name.textContent !== '“' + label + '”') name.textContent = '“' + label + '”';
    }

    function refresh() {
      // Judge.me may set up its settings after this script runs; the hook installs only once.
      takeOverJudgeMeScroll();
      addPets(app);
      syncSearch();
      clampLong(app);
      addPhotoChips(app);
    }
    refresh();
    new MutationObserver(refresh).observe(app, { childList: true, subtree: true });

    // A tag lists its reviews; tapping it again, or "Show all reviews" on the line above the list, lists all again.
    tags.forEach(function (tag) {
      tag.addEventListener('click', function () {
        var widget = widgetIn(root);
        if (!widget) return;
        var on = tag.getAttribute('aria-pressed') === 'true';
        runSearch(widget, on ? '' : tag.dataset.tlbSearch);
        syncSearch();
        if (!on) scrollToList(widget);
      });
    });
    var foundClear = root.querySelector('[data-tlb-found-clear]');
    if (foundClear) {
      foundClear.addEventListener('click', function () {
        var widget = widgetIn(root);
        // "Show all reviews" means all of them. With a star filter on, the search word is emptied quietly
        // and Judge.me's own clear drops both in one request.
        var field = searchField(widget);
        if (field && clear && !clear.hidden) {
          field.value = '';
          pressJudgeMe(widget, null);
          setActive(null);
        } else {
          runSearch(widget, '');
        }
        syncSearch();
      });
    }

    var rows = root.querySelectorAll('[data-tlb-rating]');
    var clear = root.querySelector('[data-tlb-clear]');

    // A newer Judge.me widget has no histogram rows to press; the bars then stay as plain counts.
    var start = widgetIn(root);
    if (!start || !start.querySelector('.jdgm-histogram__row')) {
      rows.forEach(function (b) { b.disabled = true; });
    }

    function setActive(btn) {
      rows.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      if (clear) clear.hidden = !btn;
    }

    rows.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var widget = widgetIn(root);
        if (!widget) return;
        var next = btn.getAttribute('aria-pressed') === 'true' ? null : btn;
        if (!pressJudgeMe(widget, next && next.dataset.tlbRating)) return;
        setActive(next);
        scrollToList(widget);
      });
    });

    if (clear) {
      clear.addEventListener('click', function () {
        var widget = widgetIn(root);
        if (widget) pressJudgeMe(widget, null);
        setActive(null);
      });
    }

    // "See all photos" opens Judge.me's photo viewer when the widget has one.
    root.querySelectorAll('[data-tlb-photos]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var widget = widgetIn(root);
        var thumb = widget && widget.querySelector('.jdgm-gallery__thumbnail-link');
        if (!thumb) return;
        event.preventDefault();
        thumb.click();
      });
    });
  }

  // The star badge under the product title lands on the whole block (score, photos) instead of only
  // the Judge.me list inside it. Capture phase, so it runs before the theme's and Judge.me's own scroll.
  // Badges elsewhere (product cards) keep their normal behaviour.
  document.addEventListener('click', function (event) {
    var badge = event.target.closest && event.target.closest('.hdt-product__info-container .jdgm-preview-badge');
    var root = badge && document.querySelector('[data-tlb-reviews]');
    if (!root || !root.offsetHeight) return;
    event.preventDefault();
    event.stopPropagation();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);

  function initAll() {
    document.querySelectorAll('[data-tlb-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-tlb-reviews]'));
  });
})();
